"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.textAreaRegex = exports.removeSpaces = exports.onlyLettersWithSpaces = exports.onlyLettersUpperCaseWithSpaces = exports.onlyLettersAndNumbers = exports.numericWithoutDecimal = exports.numericMask = exports.lettersAndNumbersWithSpaces = exports.alphaMaskWithSpaces = exports.alphaMaskWithPunctuation = exports.alphaMask = exports.alphaEmailMask = void 0;

var alphaMask = function alphaMask(len) {
  return Array.from({
    length: len
  }, function () {
    return /^[\w]+$/;
  });
};

exports.alphaMask = alphaMask;

var onlyLettersWithSpaces = function onlyLettersWithSpaces(len) {
  return Array.from({
    length: len
  }, function () {
    return /^[a-zA-Z\s]+$/;
  });
};

exports.onlyLettersWithSpaces = onlyLettersWithSpaces;

var onlyLettersAndNumbers = function onlyLettersAndNumbers(len) {
  return Array.from({
    length: len
  }, function () {
    return /^[a-zA-Z0-9]+$/;
  });
};

exports.onlyLettersAndNumbers = onlyLettersAndNumbers;

var lettersAndNumbersWithSpaces = function lettersAndNumbersWithSpaces(len) {
  return Array.from({
    length: len
  }, function () {
    return /^[a-zA-Z0-9\s]+$/;
  });
};

exports.lettersAndNumbersWithSpaces = lettersAndNumbersWithSpaces;

var alphaEmailMask = function alphaEmailMask(len) {
  return Array.from({
    length: len
  }, function () {
    return /^[\w@.]+$/;
  });
};

exports.alphaEmailMask = alphaEmailMask;

var alphaMaskWithSpaces = function alphaMaskWithSpaces(len) {
  return Array.from({
    length: len
  }, function () {
    return /^[\w\s]+$/;
  });
};

exports.alphaMaskWithSpaces = alphaMaskWithSpaces;

var alphaMaskWithPunctuation = function alphaMaskWithPunctuation(len) {
  return Array.from({
    length: len
  }, function () {
    return /^[\w\s.,;!¡:']+$/;
  });
};

exports.alphaMaskWithPunctuation = alphaMaskWithPunctuation;

var numericMask = function numericMask(len) {
  return Array.from({
    length: len
  }, function () {
    return /^\d+$/;
  });
};

exports.numericMask = numericMask;

var removeSpaces = function removeSpaces(string) {
  return string.replace(/\s{2,}/, ' ');
};

exports.removeSpaces = removeSpaces;
var textAreaRegex = /[()[\]|&;$%@#"{}¿!¡?^/\\|<>+~=`':*¨]/g;
exports.textAreaRegex = textAreaRegex;

var numericWithoutDecimal = function numericWithoutDecimal(length) {
  return Array.from({
    length: length
  }, function () {
    return /^[0-9]*$/;
  });
};

exports.numericWithoutDecimal = numericWithoutDecimal;

var onlyLettersUpperCaseWithSpaces = function onlyLettersUpperCaseWithSpaces(len) {
  return Array.from({
    length: len
  }, function () {
    return /^[A-Z\s]+$/;
  });
};

exports.onlyLettersUpperCaseWithSpaces = onlyLettersUpperCaseWithSpaces;